<script lang="ts">
    import type {OptionGridFieldValue} from '../../../../lib/types';
    import KpChipTag from 'shared/ui-widgets/chip/KpChipTag.svelte';

    export let value: OptionGridFieldValue;
</script>

<KpChipTag additionalClasses="kp-grid-codebook-value" chipSize="xs">
    <span title={`${value.id}`}>{value.text}</span>
</KpChipTag>